import React, { useEffect } from "react";

import { Box } from "@mui/material";
import { CloseIcon } from "../../../components/Icons";
import { GridAutoColumns } from "../../../styles/global.style";
import { IPetItemResponse } from "../../../services/pet-list/pet-list.interface";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { MODALS } from "../../../config/params";
import { PetCard } from "../../../components";
import { SecondaryButton } from "../../../styles/styledComponents";
import { useModal } from "../../../context/ModalContext";
import { useNavigate } from "react-router-dom";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { userActivityLogger } from "../../../utils/mixpanel";

const SelectPetModal = () => {
  const { petList: petsActive } = usePetStore();
  const navigate = useNavigate();
  const { closeModal, openModal }=useModal();

  useEffect(()=>{
    if (petsActive?.length==0) {
      openModal(MODALS.ADD_A_PET);
    }
  }, [petsActive]);


  const handleClose = () =>{
    closeModal();
  };

  const handleSelectPet = (petId: string) => {
    userActivityLogger(MIXPANEL_EVENTS.USER_CHECKS_PAST_VISIT, { start_from: "Dashboard" });
    navigate(`pet-care?id=${petId}&category=Health_Records`);
  };


  return (
    <>
      <div className="flex justify-end">
        <CloseIcon
          onClick={handleClose}
          className="text-light-black cursor-pointer mt-1"
        /></div>
      <div className="text-lg w-full font-semibold flex justify-center mt-1 cursor-default">Select a Pet</div>
      <Box className="h-full flex flex-col justify-between flex-1 overflow-y-auto basis-0 p-6 pe-4 pb-0">
        <div>
          <GridAutoColumns>
            {petsActive?.map((pet: IPetItemResponse) => (
              <a
                key={pet.id}
                className="link petItemLink w-full"
                onClick={() => handleSelectPet(pet.id)}
              >
                <PetCard
                  image={pet.image}
                  pet={pet}
                  notBold={false}
                />
              </a>
            ))}
          </GridAutoColumns>
        </div>
      </Box>
      <Box className="!sticky !bottom-0 !bg-gray-2 w-full pt-2">

        <SecondaryButton fullWidth
          type={"button"} className="grow !text-base font-semibold !p-3 !h-10" onClick={handleClose}>
              Cancel
        </SecondaryButton>
      </Box>
    </>
  );
};

export default SelectPetModal;
